var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 675.000002",
    height: 900,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d12b46d7fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef61baa534"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c6b2b30a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.570312 0 L 632.429688 0 C 697.054688 0 749.445312 52.390625 749.445312 117.015625 L 749.445312 556.988281 C 749.445312 621.613281 697.054688 674 632.429688 674 L 117.570312 674 C 52.945312 674 0.554688 621.613281 0.554688 556.988281 L 0.554688 117.015625 C 0.554688 52.390625 52.945312 0 117.570312 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d6ba8b6f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 244 27.386719 L 482.992188 27.386719 L 482.992188 646.71875 L 244 646.71875 Z M 244 27.386719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f223afa221"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 86 L 270 86 L 270 111 L 232.113281 111 Z M 232.113281 86 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e1d6791436"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 127 L 270 127 L 270 152 L 232.113281 152 Z M 232.113281 127 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc5cbab9f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 167 L 270 167 L 270 193 L 232.113281 193 Z M 232.113281 167 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38748c796b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 208 L 270 208 L 270 234 L 232.113281 234 Z M 232.113281 208 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74102ebf6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 249 L 270 249 L 270 274 L 232.113281 274 Z M 232.113281 249 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b82b4543f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 290 L 270 290 L 270 315 L 232.113281 315 Z M 232.113281 290 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1b5cd701b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 330 L 270 330 L 270 356 L 232.113281 356 Z M 232.113281 330 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b068da79c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 232.113281 371 L 270 371 L 270 397 L 232.113281 397 Z M 232.113281 371 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d12b46d7fb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 681.492188 L 0.554688 681.492188 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef61baa534)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c6b2b30a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c9ce5",
    d: "M 0.554688 0 L 749.445312 0 L 749.445312 674 L 0.554688 674 Z M 0.554688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d6ba8b6f6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 363.488281 51.863281 C 340.933594 51.863281 314.589844 62.535156 314.589844 92.605469 L 314.589844 446.195312 L 309.363281 449.84375 C 283.941406 467.589844 268.746094 496.632812 268.746094 527.515625 C 268.746094 579.753906 311.25 622.25 363.488281 622.25 C 415.730469 622.25 458.226562 579.753906 458.226562 527.515625 C 458.226562 496.632812 443.046875 467.589844 417.617188 449.84375 L 412.390625 446.195312 L 412.390625 92.605469 C 412.390625 62.535156 386.050781 51.863281 363.488281 51.863281 Z M 363.488281 646.6875 C 297.773438 646.6875 244.304688 593.226562 244.304688 527.515625 C 244.304688 490.816406 261.320312 456.195312 290.148438 433.664062 L 290.148438 92.605469 C 290.148438 54.21875 320.3125 27.417969 363.488281 27.417969 C 406.675781 27.417969 436.839844 54.21875 436.839844 92.605469 L 436.839844 433.664062 C 465.660156 456.195312 482.675781 490.816406 482.675781 527.515625 C 482.675781 593.226562 429.203125 646.6875 363.488281 646.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 395.582031 460.519531 L 395.582031 248.570312 L 331.40625 248.570312 L 331.40625 460.519531 C 306.414062 472.507812 289.125 497.957031 289.125 527.515625 C 289.125 568.585938 322.425781 601.871094 363.488281 601.871094 C 404.570312 601.871094 437.863281 568.585938 437.863281 527.515625 C 437.863281 497.957031 420.566406 472.507812 395.582031 460.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f223afa221)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 110.933594 L 232.589844 110.933594 L 232.589844 86.492188 L 269.265625 86.492188 L 269.265625 110.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e1d6791436)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 151.671875 L 232.589844 151.671875 L 232.589844 127.234375 L 269.265625 127.234375 L 269.265625 151.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc5cbab9f3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 192.417969 L 232.589844 192.417969 L 232.589844 167.980469 L 269.265625 167.980469 L 269.265625 192.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38748c796b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 233.160156 L 232.589844 233.160156 L 232.589844 208.71875 L 269.265625 208.71875 L 269.265625 233.160156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74102ebf6f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 273.90625 L 232.589844 273.90625 L 232.589844 249.460938 L 269.265625 249.460938 L 269.265625 273.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b82b4543f1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 314.636719 L 232.589844 314.636719 L 232.589844 290.199219 L 269.265625 290.199219 L 269.265625 314.636719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1b5cd701b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 355.382812 L 232.589844 355.382812 L 232.589844 330.9375 L 269.265625 330.9375 L 269.265625 355.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b068da79c2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 269.265625 396.125 L 232.589844 396.125 L 232.589844 371.683594 L 269.265625 371.683594 L 269.265625 396.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.5d129fa872a8fc835f49c4483095752f.svg";
export { ForwardRef as ReactComponent };